import '../../../../overlays/modal/Modal.css';
import './DataTableSettingsModal.css';
export var footer = '_115i8c20-3-12-1';
export var footerWithMessage = '_115i8c21-3-12-1';